import { CurrentStep, StepAction, StepState } from "./types"

const findFirstFalseStep = (step: StepState): number | null => {
    const entries = Object.entries(step)
    const firstFalse = entries.find(([, value]) => !value)
    if (firstFalse) {
        return parseInt(firstFalse[0].replace("step", ""))
    }
    return null
}

export const changeStep = (
    state: {
        currentStep: CurrentStep
        stepStatus: StepState
    },
    action: StepAction
) => {
    switch (action.type) {
        case "nextStep": {
            const count = state.currentStep.currentStep
            const steps = { ...state.stepStatus }

            const currentStepKey = `step${count + 1}` as keyof StepState
            steps[currentStepKey] = true

            const nextStepNumber = findFirstFalseStep(steps)
            return {
                currentStep: {
                    currentStep:
                        nextStepNumber !== null ? nextStepNumber - 1 : count,
                },
                stepStatus: steps,
            }
        }
        case "prevStep": {
            const count = state.currentStep.currentStep
            return {
                ...state,
                currentStep: {
                    currentStep: Math.max(0, count - 1),
                },
            }
        }
        case "setStepStatus": {
            return {
                ...state,
                stepStatus: {
                    ...state.stepStatus,
                    [action.key]: action.value,
                },
            }
        }
        default:
            return state
    }
}
